import { render, staticRenderFns } from "./index-v1.vue?vue&type=template&id=36d0c72a&scoped=true&"
import script from "./index-v1.vue?vue&type=script&lang=js&"
export * from "./index-v1.vue?vue&type=script&lang=js&"
import style0 from "./index-v1.vue?vue&type=style&index=0&id=36d0c72a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0c72a",
  null
  
)

export default component.exports